import { AuthError, EventMessage, EventType } from "@azure/msal-browser";
import { get } from "lodash";
import { ReactNode, useEffect } from "react";
import { msalInstance } from ".";
import { getb2cPolicies } from "../../../../authConfig";
import { AUTH_ERROR_CODES, DEFAULT_LOCALE } from "../../constants";

const MsalEventWrapper = (props: { children?: ReactNode }) => {
    const { children } = props;

    useEffect(() => {
        const eventCallback = (event: EventMessage) => {
            const b2cPolicies = getb2cPolicies();

            if (
                event.eventType === EventType.LOGIN_SUCCESS &&
                get(event, "payload.account")
            ) {
                const payload: any = event.payload;

                msalInstance.setActiveAccount(payload?.account);
            }

            const error = event.error;

            if (error instanceof AuthError) {
                if (event.eventType === EventType.LOGIN_FAILURE) {
                    if (
                        error?.errorMessage?.indexOf(
                            AUTH_ERROR_CODES.FORGOT_PASSWORD
                        ) > -1
                    ) {
                        try {
                            const request: any = {
                                ...b2cPolicies.authorities.resetPassword,
                                extraQueryParameters: {
                                    ui_locales:
                                        document.documentElement.lang ||
                                        DEFAULT_LOCALE,
                                },
                            };
                            msalInstance.loginRedirect(request);
                        } catch (err) {
                            console.log(err);
                        }
                    } else if (
                        error?.errorMessage?.indexOf(
                            AUTH_ERROR_CODES.USER_CANCELLATION
                        ) > -1
                    ) {
                        try {
                            const request: any = {
                                ...b2cPolicies.authorities.signUpSignIn,
                                extraQueryParameters: {
                                    ui_locales:
                                        document.documentElement.lang ||
                                        DEFAULT_LOCALE,
                                },
                            };
                            msalInstance.loginRedirect(request);
                        } catch (err) {
                            console.log(err);
                        }
                    }
                } else if (
                    event.eventType === EventType.ACQUIRE_TOKEN_FAILURE
                ) {
                    if (
                        error?.errorMessage?.indexOf(
                            AUTH_ERROR_CODES.NO_EXISTING_SESSION
                        ) > -1
                    ) {
                        msalInstance.logoutRedirect();
                    }
                }
            }
        };

        const callbackId = msalInstance.addEventCallback(eventCallback);

        return () => {
            if (callbackId) {
                msalInstance.removeEventCallback(callbackId);
            }
        };
    }, []);

    return <>{children}</>;
};

export { MsalEventWrapper };
